/**
 * Created by Owner on 2016/8/6.
 * 组选  组选120  组选24
 *  selectArea: {
          layout: [
            {
              title: "组选120",
              no: "0|1|2|3|4|5|6|7|8|9",
              minchosen: 5
            }
          ],
          noBigIndex: 5,
 */
import {Component} from '@angular/core';
import {SelectMarkNum} from "../selectMarkNum/selectMarkNum";
import {LotteryMathZXFSComponent} from "./zxfs";
import {MathUtil} from "../../util/mathUtil";

@Component({
  selector: 'lottery-math-zh1',
  templateUrl: 'selectMathAndPostion.html',
})
export class LotteryMathZH1Component extends LotteryMathZXFSComponent {

  changeTotal(selectInfo:any) {
    let tmpTotal: number = 0;
    let selectMarkNum: SelectMarkNum = this.children.toArray()[0];
    let noLength = selectMarkNum.selectNo.length;
    let minchosen = selectMarkNum.getSelectOption()["minchosen"];
    let isrx = this.selectAreaOption["isrx"];
    let mname = this.selectAreaOption["mname"];
    let selLength = this.defaultPosition.length;
    let nameFn = {
      'WXZU120': ()=> {
        if (noLength > (minchosen - 1)) {
          tmpTotal += MathUtil.combination(noLength, minchosen);
        }
        return tmpTotal;
      },
      'SXZU24': ()=> {
        var s = noLength;
        if (s > 3) {
          tmpTotal += MathUtil.combination(s, 4);
        }
        if (isrx == 1) {
          tmpTotal *= selLength == 0 ? 0 : MathUtil.combination(selLength, 4);
        }
        return tmpTotal;
      },
      'SXZU6': ()=> this.math1(noLength, minchosen, selLength, isrx),
      'LTZU3': ()=> this.math1(noLength, minchosen, selLength),
      'LTZU2': ()=> this.math1(noLength, minchosen, selLength),
      'LTBDW': ()=> this.math1(noLength, minchosen, selLength),
      'LTCZW': ()=> this.math1(noLength, minchosen, selLength),
      'LTRX1': ()=> this.math1(noLength, minchosen, selLength),
      'LTRX2': ()=> this.math1(noLength, minchosen, selLength),
      'LTRX3': ()=> this.math1(noLength, minchosen, selLength),
      'LTRX4': ()=> this.math1(noLength, minchosen, selLength),
      'LTRX5': ()=> this.math1(noLength, minchosen, selLength),
      'LTRX6': ()=> this.math1(noLength, minchosen, selLength),
      'LTRX7': ()=> this.math1(noLength, minchosen, selLength),
      'LTRX8': ()=> this.math1(noLength, minchosen, selLength)
    };
    tmpTotal = nameFn[mname]();
    this.setTotal(tmpTotal);
  }

  math1(noLength, minchosen, selLength, isrx = 0) {
    let tmpTotal: number = 0;
    if (noLength >= minchosen) {
      tmpTotal += MathUtil.combination(noLength, minchosen)
    }
    if (isrx == 1) {
      tmpTotal *= selLength == 0 ? 0 : MathUtil.combination(selLength, 4)
    }
    return tmpTotal;
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/zh1.ts